export default __webpack_public_path__ + "static/media/invoice-paid.3b9743cc.svg";